import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=c2493adc&scoped=true"
import script from "./AddCourse.vue?vue&type=script&lang=js"
export * from "./AddCourse.vue?vue&type=script&lang=js"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=c2493adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2493adc",
  null
  
)

export default component.exports